// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import axiosInstance from "../../../util/axiosInstance";
// import { Apiurl } from "../../../util/apiurl";
// import { Worker, Viewer } from "@react-pdf-viewer/core";
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import { Modal, Button, Form } from "react-bootstrap";

// function ViewEbook() {
//   const { id } = useParams();
//   const [loading, setLoading] = useState(false);
//   const [ebook, setEbook] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [captcha, setCaptcha] = useState(false);
//   const [downloadError, setDownloadError] = useState("");

//   useEffect(() => {
//     fetchEbook();
//   }, []);

//   const fetchEbook = async () => {
//     setLoading(true);
//     try {
//       const response = await axiosInstance.get(`${Apiurl.ebookView}/${id}`);
//       setEbook(response.data);
//     } catch (error) {
//       console.error("Error fetching ebook details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownloadClick = () => {
//     setShowModal(true);
//   };

//   const handleDownload1 = async () => {
//     try {
//       const response = await axiosInstance.post(`${Apiurl.ebookDownload}`, {
//         // id,
//         // name,
//         // email,
//         // captcha
//         id: id,
//         userName: name,
//         email: email,
//         notARobot: captcha,
//       });
//       if (response) {
//         // Download the PDF
//         const link = document.createElement("a");
//         link.href = ebook.pdfContent;
//         link.setAttribute("download", `${ebook.bookName}.pdf`);
//         document.body.appendChild(link);
//         link.click();
//         link.remove();
//         setShowModal(false);
//       } else {
//         // setDownloadError('Invalid user');
//       }
//     } catch (error) {
//       console.error("Error downloading ebook:", error);
//       setDownloadError("Error downloading ebook");
//     }
//   };
//   const handleDownload = async () => {
//     try {
//       const response = await axiosInstance.post(`${Apiurl.ebookDownload}`, {
//         id: id,
//         userName: name,
//         email: email,
//         notARobot: captcha,
//       });

//       if (response) {
//         // Check if `ebook.pdfContent` is base64 encoded
//         const base64Content = ebook.pdfContent.split(";base64,").pop();

//         if (base64Content) {
//           // Convert base64 to blob
//           const byteCharacters = atob(base64Content);
//           const byteNumbers = new Array(byteCharacters.length);
//           for (let i = 0; i < byteCharacters.length; i++) {
//             byteNumbers[i] = byteCharacters.charCodeAt(i);
//           }
//           const byteArray = new Uint8Array(byteNumbers);
//           const blob = new Blob([byteArray], { type: "application/pdf" });

//           // Create a download link and trigger download
//           const url = window.URL.createObjectURL(blob);
//           const link = document.createElement("a");
//           link.href = url;
//           link.setAttribute("download", `${ebook.bookName}.pdf`);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//           window.URL.revokeObjectURL(url); // Clean up the URL after download
//           setShowModal(false);
//         } else {
//           setDownloadError("PDF content is not valid.");
//         }
//       }
//     } catch (error) {
//       console.error("Error downloading ebook:", error);
//       setDownloadError("Error downloading ebook");
//     }
//   };

//   const handleClose = () => {
//     setShowModal(false);
//     setDownloadError(""); // Clear error when closing the modal
//   };

//   // Clear the error when user inputs change
//   const handleInputChange = (setter) => (e) => {
//     setter(e.target.value);
//     setDownloadError("");
//   };

//   const handleCaptchaChange = (e) => {
//     setCaptcha(e.target.checked);
//     setDownloadError("");
//   };

//   return (
//     <>
//       {loading ? (
//         <>loading..</>
//       ) : (
//         ebook && (
//           <div className="ebook-view container">
//             <div className="bookname">{ebook.bookName}</div>
//             <img src={ebook.coverImage} alt={ebook.bookName} />
//             <div className="book-desc">{ebook.description}</div>
//             <Button className="pdf-download-btn" onClick={handleDownloadClick}>
//               Download
//             </Button>
//             <div className="pdf-content">
//               <Worker
//                 workerUrl={`https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js`}
//               >
//                 <Viewer fileUrl={`${ebook.pdfContent}`} />
//               </Worker>
//             </div>

//             <Modal show={showModal} onHide={handleClose}>
//               <Modal.Header closeButton>
//                 <Modal.Title>Download Ebook</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <Form>
//                   <Form.Group controlId="formName">
//                     <Form.Label>Name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       value={name}
//                       onChange={handleInputChange(setName)}
//                     />
//                   </Form.Group>
//                   <Form.Group controlId="formEmail">
//                     <Form.Label>Email</Form.Label>
//                     <Form.Control
//                       type="email"
//                       value={email}
//                       onChange={handleInputChange(setEmail)}
//                     />
//                   </Form.Group>
//                   <Form.Group controlId="formCaptcha">
//                     <Form.Check
//                       type="checkbox"
//                       label="I'm not a robot"
//                       checked={captcha}
//                       onChange={handleCaptchaChange}
//                     />
//                   </Form.Group>
//                   {downloadError && (
//                     <p className="text-danger">{downloadError}</p>
//                   )}
//                 </Form>
//               </Modal.Body>
//               <Modal.Footer>
//                 <Button variant="secondary" onClick={handleClose}>
//                   Cancel
//                 </Button>
//                 <Button variant="primary" onClick={handleDownload}>
//                   Download PDF
//                 </Button>
//               </Modal.Footer>
//             </Modal>
//           </div>
//         )
//       )}
//     </>
//   );
// }

// export default ViewEbook;



// const handleDownload = () => {
  //   if (ebook && ebook.pdfContent) {
  //     const pdfBlob = base64ToBlob(ebook.pdfContent, 'application/pdf');
  //     const downloadUrl = URL.createObjectURL(pdfBlob);
  //     const link = document.createElement('a');
  //     link.href = downloadUrl;
  //     link.download = ebook.pdfFileName || 'download.pdf';
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(downloadUrl);
  //     setShowModal(false);
  //   } else {
  //     setDownloadError('PDF content not available');
  //   }
  // };



import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../util/axiosInstance";
import { Apiurl } from "../../../util/apiurl";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { Modal, Button, Form } from "react-bootstrap";
import ShareButtons from "../../layout/shareButtons";
import Loader from "../../layout/lodaer";

function ViewEbook() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [ebook, setEbook] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [captcha, setCaptcha] = useState(false);
  const [downloadError, setDownloadError] = useState("");
  const [pdfError, setPdfError] = useState(null);


  const shareUrl = 'https://finlabsweb.finlabsindia.org/EbookMain';
  const title = 'Check out this amazing website!';


  useEffect(() => {
    fetchEbook();
  }, []);

  useEffect(() => {
    if (ebook && ebook.pdfContent) {
      const pdfBlob = base64ToBlob(ebook.pdfContent, 'application/pdf');
      const pdfObjectUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfObjectUrl);

      return () => URL.revokeObjectURL(pdfObjectUrl);
    }
  }, [ebook]);

  const fetchEbook = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${Apiurl.ebookView}/${id}`);
      console.log("Ebook data:", response.data);
      setEbook(response.data);
    } catch (error) {
      console.error("Error fetching ebook details:", error);
      setPdfError("Failed to load ebook details");
    } finally {
      setLoading(false);
    }
  };

  const base64ToBlob = (base64, type = 'application/pdf') => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: type });
  };

  const handleDownloadClick = () => {
    setShowModal(true);
  };


  
  const handleDownload = async () => {
    // Check for form validation before attempting to download
    if (!name) {
      setDownloadError("Please enter your name.");
      return;
    }
    if (!email) {
      setDownloadError("Please enter your email.");
      return;
    }
    if (!captcha) {
      setDownloadError("Please confirm you are not a robot.");
      return;
    }
  
    try {
      const response = await axiosInstance.post(`${Apiurl.ebookDownload}`, {
        id: id,
        userName: name,
        email: email,
        notARobot: captcha,
      });
  
      if (response) {
        // Check if `ebook.pdfContent` is base64 encoded
        const base64Content = ebook.pdfContent.split(";base64,").pop();
  
        if (base64Content) {
          // Convert base64 to blob
          const byteCharacters = atob(base64Content);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
  
          // Create a download link and trigger download
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${ebook.bookName}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url); // Clean up the URL after download
          setShowModal(false);
          setDownloadError(""); // Clear any previous errors
        } else {
          setDownloadError("PDF content is not valid.");
        }
      }
    } catch (error) {
      console.error("Error downloading ebook:", error);
      setDownloadError("Error downloading ebook");
    }
  };
     
  const handleClose = () => {
    setShowModal(false);
    setDownloadError("");
  };

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    setDownloadError("");
  };

  const handleCaptchaChange = (e) => {
    setCaptcha(e.target.checked);
    setDownloadError("");
  };

  const renderPdf = () => {
    if (!pdfUrl) {
      return <div>No PDF preview available</div>;
    }

    return (
      <div style={{ height: '600px', overflow: 'auto', border: '1px solid #ccc' }}>
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
          <Viewer
            fileUrl={pdfUrl}
            defaultScale={1}
            onError={(error) => {
              console.error("PDF viewer error:", error);
              setPdfError("Failed to load PDF");
            }}
          />
        </Worker>
      </div>
    );
  };

  if (loading) {
    return <div><Loader/></div>;
  }

  if (pdfError) {
    return <div>Error: {pdfError}</div>;
  }

  return (
    <>
      {ebook && (
        <div className="ebook-view container">
          <div className="bookname">{ebook.bookName}</div>
          <img src={ebook.coverImage} alt={ebook.bookName} />
          <div className="book-desc">{ebook.description}</div>
          <div className="utility">

            <Button className="pdf-download-btn " onClick={handleDownloadClick} >
              Download <i className="fa fa-download"></i>
            </Button>
            <span className="share-section">
              <ShareButtons url={shareUrl} title={title} />
            </span>
          </div>
          <div className="pdf-content">
            {renderPdf()}
          </div>

          <Modal show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Download Ebook</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="formName" className="mb-3">
                  <Form.Label>Name <span className="errmark">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    value={name}
                    onChange={handleInputChange(setName)}
                  />
                </Form.Group>
                <Form.Group controlId="formEmail" className="mb-3">
                  <Form.Label>Email <span className="errmark">*</span></Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={handleInputChange(setEmail)}
                  />
                </Form.Group>
                <Form.Group controlId="formCaptcha" className="mb-3 d-flex">
                  <Form.Check
                    type="checkbox"
                    label="I'm not a robot"
                    checked={captcha}
                    onChange={handleCaptchaChange}
                    
                  />
                  <span className="errmark mx-1">*</span>
                </Form.Group>
                {downloadError && (
                  <p className="text-danger">{downloadError}</p>
                )}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleDownload} className="footer-main">
                Download PDF
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
}

export default ViewEbook;
